// Colour tokens as "r g b" so Tailwind's /<alpha> modifiers keep working.
/** DARK is today's console, byte for byte; LIGHT is the Editorial canvas
 *  (spec 2026-10-03 §6). The names mirror tailwind.config.js.
 *  paper-trace was bumped 2026-05-04 from #4a4740 to lift narrative body
 *  copy out of near-illegible 3:1 contrast against ink-700 background.
 *  Still distinct from `paper-faint` for hierarchy. */
export const DARK_TOKENS: Record<string, string> = {
  'ink-900': '10 13 18', 'ink-800': '15 19 26', 'ink-700': '18 22 29', 'ink-600': '23 28 38',
  'ink-500': '31 37 48', 'ink-400': '42 49 61',
  'paper': '232 226 212', 'paper-dim': '183 177 163', 'paper-faint': '131 126 115', 'paper-trace': '122 118 106',
  'amber-glow': '255 182 72', 'amber-deep': '199 125 31',
  'radar-cyan': '94 234 255', 'radar-green': '127 224 138', 'radar-red': '255 88 80', 'radar-violet': '182 156 255',
}

export const LIGHT_TOKENS: Record<string, string> = {
  'ink-900': '243 244 246', 'ink-800': '247 248 250', 'ink-700': '255 255 255', 'ink-600': '238 240 243',
  'ink-500': '225 228 233', 'ink-400': '205 209 216',
  'paper': '22 24 29', 'paper-dim': '59 64 73', 'paper-faint': '90 96 108', 'paper-trace': '107 112 121',
  'amber-glow': '163 79 11', 'amber-deep': '138 66 9',
  'radar-cyan': '14 85 99', 'radar-green': '24 92 50', 'radar-red': '163 38 27', 'radar-violet': '91 63 176',
}

export type ThemePref = 'light' | 'dark' | 'system'

export function resolveTheme(pref: ThemePref, systemDark: boolean): 'light' | 'dark' {
  if (pref === 'system') return systemDark ? 'dark' : 'light'
  return pref
}
